import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ciscoFtdv = defineConnector({
  identifier: "ciscoFtdv",
  name: "Cisco FTDv",
  tagLine: "Virtual firewall threat defense management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.host}/api/fdm/latest/fdm/token`,
        jsonBody: {
          grant_type: "password",
          username: app.config.username,
          password: app.secret.password,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Prepare your FDM credentials",
      items: [
        {
          kind: "markdown",
          content:
            "You’ll need an administrator account on your Firepower Device Manager (FDM) with REST API access.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "FTDv host",
          required: true,
          placeholder: "ftdv.example.com",
          helperText: "Your Firepower Device Manager hostname or IP address.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) =>
      `https://${host}/api/fdm/latest/operational/systeminfo`,
  },
});
